/* src/app/warehousing/pages/locations-new/locations-new.component.scss */
/*# sourceMappingURL=locations-new.component.css.map */
